<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" styleClass="cat-Exception-confirm-dialog-box" appendTo="body" id="catExceptionConfirmation" ></p-confirmDialog>

<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    [FilterFieldDefaultValues]="filterFieldDefaultValues"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- End of Quick search common component -->

<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
    [ResetLabel]="isFilterLabelReset" (FilterEvent)="FilterApplyFilterEvent($event)"
    (FilterEventClearSymbol)="FilterEventClearSymbol($event)" (FilterEventClearCode)="FilterEventClearCode($event)">
  </app-filter-panel>
</div>

<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  <app-symbol-panel [SymbolArray]="SymbolsArray" [CodeArray]="CodesArray" [ResetLabel]="ResetLabel"
    [rowCount]="totalRecords" [rowCountSymbol]="totalRecords" (ActiveSymbolEvent)="setActiveSymbolEvent($event)"
    (ActiveCodeEvent)="setActiveCodeEvent($event)">
  </app-symbol-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  <div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu>  
  <!--Grid Code  -->
  <p-table #dt 
    [value]="dataset1"
    [class.catExceptiontable-frozen]="commonColService.isFrozenColumns"
    [columns]="commonColService.selectedColumns"
    [resizableColumns]="true"
    [lazy]="true"
    (onPage)="changePage($event)"
    [sortOrder]="constantService.DEFAULT_SORDORDER_ASC"
    [(selection)]="selectedRow"
    [paginator]="true"
    selectionMode="multiple"
    appendTo="body"
    (onSort)="sort($event)"
    alwaysShowPaginator="true"
    paginatorPosition="both"
    showCurrentPageReport="true"
    [rows]="constantService.DEFAULT_ROWSIZE"
    [totalRecords]="totalRecords"
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" 
    sortMode="multiple"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [scrollable]="true" 
    scrollHeight="60vh"
    [reorderableColumns]="true"
    (onColReorder)="commonColService.onColumnsReordered($event, dt)"
    styleClass ="cat-exception-table">
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{constantService.NO_RECORDFOUND_MSG}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th id="catExceptiontableCheckbox" style="width: 3em" pFrozenColumn
        [frozen]= "commonColService.hasFrozenColumns()">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        @for(col of columns; track col.field + '-'+ $index) { 
        <th [attr.id]="'col-' + col.field" pResizableColumn [pSortableColumn]="col.field" pFrozenColumn pReorderableColumn
          [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen" 
          alignFrozen="left"
          [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
          [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
          [class.selected-header]="commonColService.selectedFields.includes(col.field)"
          (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
          (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
          (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt)"
          [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <div class="header-cell-content">
          <span [class.excel-cursor-span]="(col.header | lowercase) !== 'action'"  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{col.header}}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
          </span>
            @if(col.frozen) {
                          <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 4px;"></i>
                      }
          </div>
        </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['modifiedFlag'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['modifiedFlag'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        <td style="width: 3em;padding-left: 6px !important;" pFrozenColumn
                [frozen]= "commonColService.hasFrozenColumns()">
          <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row" (click)="displayDropdownTypeBySelectedType(row);"></p-tableCheckbox>
        </td>
        @for(col of columns; track col.field + '-'+ $index) { 
        <td class="ui-resizable-column" pFrozenColumn
                [frozen]="col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen"
                alignFrozen="left"
                [style.left]="(col.field === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                [style.background-color]="selectedRow?.includes(row)? '#88c0eb': (col.frozen ? '#e2f0d9' : null)"         
                [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <!-- set String -->
           @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
          <span>
            @if((col.header | lowercase) == 'type' && (multiLegEventArray && multiLegEventArray.includes(row[col.field]))){
            <span>
              <a [matTooltip]="'Num of Legs: ' + getNumberofLegs(row)" [matTooltipShowDelay]="1000" [matTooltipPosition]="'above'" (click)="onClickMultiLegEvent(rowIndex,row)" class="multilegType">{{row[col.field]}}</a>
            </span>
            }
            @if((col.header | lowercase) =='order id'){
            <span>
              <a class="cat-exception-table-link" matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body" [id]="'OrderID'+ rowIndex" (click)="onRowSelect('OrderID',rowIndex,row)" style="color: blue;cursor: pointer">{{row[col.field]}}</a>
            </span>
            }
            @if(col.header =='Suggested Value' && isEnabledcaisFDIDService){
            <span>
                <a class="cat-exception-table-link"  appendTo="body" (click)="openDetails(row)" style="color: blue;cursor: pointer;text-decoration: none;">{{checkErrorcode(row['failureCode'],row['suggestedValue'])}}</a>          
              </span>
            }
            @if((col.header | lowercase) !='order id' && col.header !='Suggested Value' && !['symbol'].includes(col.header | lowercase) && (multiLegEventArray && !multiLegEventArray.includes(row[col.field]))){
            <span>
              {{row[col.field]}}
            </span>
            }
            @if((col.header | lowercase) == 'symbol'){
            <div class="pull-right" [ngClass]="'displayWhitespaces'">
              {{(row[col.field] ? row[col.field] : (row['optionalSymbol'] ? row['optionalSymbol'] : ''))}}
            </div>
            }
          </span>
          }
          <!-- set int  -->
           @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
          <span style="float:right;">
            {{row[col.field] * 1}}
          </span>
          }
           @if(col.header==='action'){
          <span>
             @if(commonColService.hasFrozenColumns()){
               <p-button [ngStyle]="{width:'23px'}" class="pi pi-xxx" or class="fa fa-xxx"
              matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              [id]="'view'+ rowIndex" (click)="onRowSelect('View',rowIndex,row)" [disabled] = "selectedRow.length>=2"></p-button>}
            @else{
            @if(selectedRow.length < 2){
            <p-button [ngStyle]="{width:'23px'}" class="pi pi-xxx" or class="fa fa-xxx"
              matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              [id]="'view'+ rowIndex" (click)="onRowSelect('View',rowIndex,row)"></p-button>
            }}
            @if(row[col.field] != 'D'){
            <p-button [id]="'edit'+ rowIndex" class="pi pi-xxx" or class="fa fa-xxx" 
            matTooltip="Edit" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-edit" (click)="onRowSelect('Edit',rowIndex,row);">
            </p-button>
            }
             @if(row[col.field] != 'D'){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash"
              [id]="'delete'+ rowIndex" (click)="onRowSelect('Delete',rowIndex,row)"></p-button>
             }
             @if(row[col.field] == 'D'){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Restore Deleted" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-undo"
              [id]="'restore'+ rowIndex" (click)="onRowSelect('RestoreDeleted',rowIndex,row)"></p-button>
             }
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Parent/Child Event Tree" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-tree"
              [id]="'tree'+ rowIndex"  (click)="onRowSelect('EventTree',rowIndex,row)"></p-button>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Audit-Trail" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-list"
              [id]="'audit'+ rowIndex"  (click)="onRowSelect('AuditTrail',rowIndex,row)"></p-button>
            </span>
          }
        </td>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <p-select name="newROEEntry" id="id_newROEEntry" 
      [options]="eventList"
      [(ngModel)]="selectedEventType"
      placeholder="New ROE Entry"
      (onChange)="onEventTypeChange($event);" [showClear]="true"      
      class="EventTypeDropdown">
    </p-select>
      <app-export-to-csv  [gridColumns]="exportGridColumns" (exportToCSVListner)="exportToCSV($event)" ></app-export-to-csv>
      Total Records: {{dataset1.length == 0? 0 : totalRecords}}

    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset1.length == 0? 0 : startLimit + 1}} to {{dataset1.length
            < rowcount ? dataset1.length < startLimit ? endLimit : dataset1.length : endLimit}} entries
    </ng-template>
  </p-table>
  </div>
  <br>
  <br>

</div>

<!--Edit Panel Code  -->
@if(Edit){
<p-dialog id="Edit" [(visible)]="Edit" header="" appendTo="body" height="auto" width="auto"
  [style]="{width: '78%', minWidth: '550px'}" [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize"
  maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false" (onHide)="closeDialog()" draggable="true"
  [focusOnShow]="false" styleClass = "cat-exp-edit-dialog">
  <div class="ui-grid-col-12">
    <mat-horizontal-stepper (selectionChange)="selectionChange($event)">
     
      <mat-step label="Edit Row">
        <ng-container>
          @if(this.correctCodeLength !== 0){
          <div class="row margin-box"> You are editing {{correctCodeLength}} records</div>
          }
            @for(row of selectedRow; track row.failureCode + '-'+ $index; let i = $index) { 
            <span backgroundColor="accent" class="zindex ">
              @if(i === 0){
                <ng-container>
              <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
                <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row-main">
                  <strong> Failure Code : </strong>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                  <textarea disabled style="color:red; width:100%" required type="text" pInputText
                    [(ngModel)]="row.failureCode">
                          </textarea>
                </div>
              </div>
              <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
                <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row-main">
                  <strong> Failure Description : </strong>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                  <textarea disabled style="color:red; width:93%" required type="text" pInputText
                    [(ngModel)]="row.failureDescription">
                        </textarea>
                </div>
              </div>
          
              <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
                <div class="ui-g-12 ui-md-6 ui-lg-2 quick-view-grid-row-main">
                  <strong> Actual Value : </strong>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                  <textarea disabled style="color:red; width:100%" required type="text" pInputText
                    [(ngModel)]="row.actualValue">
                </textarea>
                </div>
              </div>
              <div class="ui-g-6 ui-md-6 ui-lg-6 quick-view-grid-row-main">
                <div class="ui-g-12 ui-md-6 ui-lg-3 quick-view-grid-row-main">
                  <strong> Suggested Value : </strong>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-9 quick-view-grid-row-main">
                  <textarea disabled style="color:green; width:93%" required type="text" pInputText
                    [(ngModel)]="row.suggestedValue">
              </textarea>
                </div>
              </div>
          </ng-container>
          }
            </span>
            }
          </ng-container>
              
              @for(editRow of Editviewcols; track editRow.field_Name + '-'+ $index; let i = $index) { 
              <ng-container>
                <span
                  [ngClass]="(editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && 
              (editRow.field_Name| lowercase) !== 'aggregatedorders'&& editRow.field_Name!=='firmDetails' && editRow.field_Name!=='handlingInstructions' &&
              (editRow.field_Name| lowercase) !== 'clientdetails' && (editRow.field_Name| lowercase) !== 'legdetails' && (editRow.field_Name| lowercase) !== 'firmdesignatedid'?'zindex ui-g-12 ui-md-12 ui-lg-4': 'zindex ui-g-12 ui-md-12 ui-lg-12'">
              @if(editRow){
                  <span>
                    @if((editRow.field_Name| lowercase) !== 'buydetails' && (editRow.field_Name| lowercase) !== 'selldetails' && (editRow.field_Name| lowercase) !== 'aggregatedorders'
                    && (editRow.field_Name| lowercase) !== 'clientdetails' && (editRow.field_Name| lowercase) !== 'legdetails' &&  editRow.field_Name!=='firmDetails' && editRow.field_Name !== 'handlingInstructions' && (editRow.field_Name| lowercase) !== 'firmdesignatedid'){
                    <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                      <div [ngClass]="this.correctCodeLength !== 0 ? 'ui-g-12 ui-md-5 ui-lg-5 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                        <label for="ui_Field_Name">{{editRow.ui_Field_Name}}</label>
                      </div>
                     
                      <div
                      [ngClass]="selectedRow[0]?.failureCode == editRow?.error_Code ? 'error ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg' :'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg'">
                        @if((editRow?.datatype | lowercase) == 'choice'){
                        <ng-container>
                          <p-select [name]="editRow.field_Name +'choice'" [id]="editRow.field_Name+'choice'"  
                          [readonly]="editRow?.field_Name =='type' || editRow.isDisable === 'true'" [options]="editRow.dropdownvalue"
                            [(ngModel)]="editRow.value" appendTo="body"  
                            [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                            [placeholder]="editRow.isMultiEdited ? 'Value cleared' : 'Enter Value'"
                            (ngModelChange)="editRow.isMultiEdited=true"
                            filter="true" required="true" [showClear]="true">
                            <ng-template let-filterCols let-row pTemplate="item">
                              <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after"
                                 [id]="filterCols.label">{{filterCols.label}}</div>
                              </div>
                            </ng-template>
                          </p-select>
                        </ng-container>
                        } 
                          @else if((editRow?.datatype | lowercase) =='int' || (editRow?.datatype | lowercase)=='float' || 
                          (editRow?.datatype | lowercase) =='number' || (editRow?.datatype | lowercase)=='bigdecimal'){
                          <ng-container>
                            <input type="number" ng-pattern="/^[0-9]$/" [name]="editRow.field_Name +'int'" [id]="editRow.field_Name+'int'" 
                            maxlength="10" required   pInputText [(ngModel)]="editRow.value"
                            [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="editRow.isMultiEdited=true" 
                            [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" />
                          </ng-container>
                          }
                          @else if((editRow?.datatype | lowercase)=='boolean'){
                          <ng-container>
                            <p-select [name]="editRow.field_Name +'boolean'" [id]="editRow.field_Name+'boolean'" [options]="BooleanDropDown" [(ngModel)]="editRow.value" appendTo="body"
                            [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                            [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" 
                            (ngModelChange)="editRow.isMultiEdited=true"
                              required="true">
                              <ng-template let-filterCols let-row pTemplate="item">
                                <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                  <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}</div>
                                </div>
                              </ng-template>
                            </p-select>
                          </ng-container>
                          }
                          @else if((editRow?.datatype | lowercase)=='string' || (editRow?.datatype | lowercase)=='char'){
                          <ng-container>
                            @if(editRow.field !='symbol' && editRow.field !='type'){
                            <input [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" [disabled]="editRow.isDisable"
                              required type="text" [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" 
                              pInputText [(ngModel)]="editRow.value" (ngModelChange)="editRow.isMultiEdited=true" />
                            }
                            @if(editRow.field =='symbol' || editRow.field =='type'){
                            <input [name]="editRow.field_Name +'string'" [id]="editRow.field_Name+'string'" [disabled]="editRow.isDisable"
                              [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText [id]="editRow.header" [(ngModel)]="editRow.value" />
                            }
                          </ng-container>
                          }
                          @else if((editRow?.datatype | lowercase)=='date'){
                          <ng-container>
                            <p-datepicker appendTo="body"
                            [name]="editRow.field_Name +'date'" [id]="editRow.field_Name+'date'"
                            [(ngModel)]="editRow.value" 
                            [iconDisplay]="'input'"
                            [showIcon]="true" 
                            [readonlyInput]="false"
                            dateFormat="yy-mm-dd"
                            [hourFormat] = "'24'"
                            [style]="{'width':'95% !important'}"
                            [placeholder] = "'Enter Value'"
                            [required] = "true"
                            [touchUI]="true"
                            inputId="editRow.field_Name+'date'" (dateChange)="singleEditFormateDatetime(editRow.datatype,'date', i)"
                            [motionOptions]="{ duration: 0 }" />
                          </ng-container>
                          }
                          @else if((editRow?.datatype | lowercase)=='datetime'){
                          <ng-container>
                            <div class="ui-g-12 nopadding ">
                              <input [name]="editRow.field_Name +'datetime'" [id]="editRow.field_Name+'datetime'" type="text" [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" pInputText
                                [(ngModel)]="editRow.value" (ngModelChange)="editRow.isMultiEdited=true" [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'"/>
                            </div>
                          </ng-container>
                        }
                        @else if((editRow?.datatype | lowercase)=='timestamp'){
                          <ng-container>
                            <div class="ui-g-12 nopadding ">
                              <input [name]="editRow.field_Name +'datetime'" [id]="editRow.field_Name+'datetime'" type="text"
                              [placeholder]="this.userService.getDateTimeTFormatePattern(editRow.field_Name)" 
                              [matTooltip]="this.userService.getDateTimeTFormatePattern(editRow.field_Name)"
                              (input)="getDateTimeTFormate(editRow.field_Name,editRow.value,i)"
                              [ngClass]="this.userService.timeStampErrorField == editRow.field_Name ?'error_timeStamp' :editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'" pInputText
                              [(ngModel)]="editRow.value"
                              (ngModelChange)="editRow.isMultiEdited=true"
                               />
                            </div>
                          </ng-container>
                          }
                          @else if((editRow?.datatype | lowercase)=='choicevalues'){
                          <ng-container>
                            @if(editRow.ui_Field_Name === 'timeInForce'){
                            <div class="ui-g-12 ui-md-6 ui-lg-4 quick-view-grid-row-hg">
                              <p-select [name]="editRow.field_Name +'choicevaluesDropdown'" [id]="editRow.field_Name+'choicevaluesDropdown'" 
                              [readonly]="editRow?.field_Name =='type'" [options]="editRow.dropdownvalue"
                                [(ngModel)]="newLabel" appendTo="body" (onChange)="setEditRowValue(i,newLabel)"
                                [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                                [placeholder]="newLabel"
                                filter="true" required="true"
                                class="timeInForceDropdown">
                                <ng-template let-filterCols let-row let-rowIndex pTemplate="item">
                                  <div class="ui-helper-clearfix" style="text-transform:capitalize">
                                    <div [matTooltip]="filterCols.description" [matTooltipShowDelay]="1000" atTooltipPosition="after" [id]="filterCols.label">{{filterCols.label}}
                                    </div>
                                  </div>
                                </ng-template>
                              </p-select>
                            </div>
                            }
                            @if(editRow.ui_Field_Name === 'timeInForce'){
                            <div class="ui-g-12 ui-md-6 ui-lg-8 quick-view-grid-row-hg">
                              <input [name]="editRow.field_Name +'choicevalues'" [id]="editRow.field_Name+'choicevalues'" required type="text" [placeholder]="editRow.isMultiEdited ?'Value cleared' : 'Enter Value'" pInputText
                                [(ngModel)]="timeInForceValue"  (ngModelChange)="editRow.isMultiEdited=true" [ngClass]="editRow.isMultiEdited ? 'input-color-edit' : 'inp-color-white'"/>
                            </div>
                            }
                          </ng-container>
                          }
                      </div>
                      @if(this.correctCodeLength !== 0 && editRow.isDisable=== 'false'){
                      <div class="ui-g-12 ui-md-1 ui-lg-1 quick-view-grid-row-hg">
                        <i pTooltip="Clear Value" (click)="clearValue(editRow)" tooltipPosition="right" class="fa fa-times cursor-pointer clear-all-icon"  aria-hidden="true"></i>
                      </div>
                      }
                    </div>
                    }
                    <!-- Nested Json Details -->
                     @if(editRow.field_Name=='firmDesignatedID'){
                    <div class="nopadding dialog-normal-form-field">
                     <div class="col-md-5 nopadding ">
                        <div class="row ">
                          <div class="col-md-3 dialog-form-field"><label for="GivenName">GivenName</label></div>
                            <div class="col-md-2"><p-toggleswitch [(ngModel)]="checked" styleClass="inputSwitch"></p-toggleswitch></div>
                            <div class="col-md-7"> <input [disabled]="!checked" placeholder="Enter givenName" [(ngModel)]="givenNameForFDID" >
                              <p-button type="button" icon="fa fa-check" [disabled]="!checked" (click)="getFDID(i)"></p-button></div>
                         </div> 
                     </div>
                     <div class="col-md-7 nopadding">
                       <div class="row">
                          <div class="col-md-4 dialog-normal-form-field"> Firm Designated ID</div>
                          <div class="col-md-1"><p-toggleswitch (click)="editRow.value = dataService.trimValue(editRow.value)" [(ngModel)]="fdidChecked" styleClass="inputSwitch"></p-toggleswitch></div>
                          <div class="col-md-7"> <input [disabled]="!fdidChecked" placeholder="Enter Firm Designated ID" (change)="editRow.value = dataService.trimValue(editRow.value)" [(ngModel)]="editRow.value" style="width: 100%"></div>
                       </div> 
                     </div>
                    </div>
                    }
                    @if((editRow.field_Name | lowercase) === 'aggregatedorders'){
                    <div class="nopadding">
                      <mat-divider></mat-divider>
                      <span class="dialog-section-header"><b>Aggregated Order Details</b></span>
                      <p-table [columns]="aggoOrdersCols" [value]="editRow.value" #dt1 class="cell-editor-table">
                        <ng-template pTemplate="header" let-columns>
                          <tr>
                            <th id="header"></th>
                            @for(col of columns; track col.header + '-'+ $index) { 
                            <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              {{col.header}}
                            </th>
                            }
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-aggoOrdersRowData let-ri="rowIndex" let-columns="columns">
                          <tr [pSelectableRow]="aggoOrdersRowData">
                            <!-- Logic of Aggo Details Add/Delete Row -->
                              @if((editRow.field_Name | lowercase)==='aggregatedorders' && (editRow.value.length === (ri+1))){
                                <td class="text-center">
                                  @if(editRow.value.length > 1) {
                                    <a (click)="dataService.removeJsonFieldDetails(editRow.value, ri);"><em class="pi pi-minus"></em></a>&nbsp;
                                  }
                                  <a (click)="dataService.addJsonFieldDetails(editRow.value, 'aggregatedOrders');"><em class="pi pi-plus"></em></a>
                                </td>
                              }
                              @if((editRow.field_Name | lowercase)==='aggregatedorders' && (editRow.value.length !== (ri+1))){
                                <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(editRow.value, ri);"><em class="pi pi-minus"></em></a></td>
                              }
                            <!-- End Logic of Aggo Details Add/Delete Row -->
                            @for(col of columns; track col.field + '-'+ $index) { 
                            <td pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  <input  [name]="col.field +'inp'" [id]="col.field+'inp'"  [(ngModel)]="aggoOrdersRowData[col.field]">
                                </ng-template>
                                <ng-template pTemplate="output">
                                  <span >
                                    {{aggoOrdersRowData[col.field]}}
                                  </span>
                                </ng-template>
                            </p-cellEditor>
                            </td>
                            }
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                    }
                    @if(editRow.field_Name=='handlingInstructions'){
                    <div class="ui-grid-col-8 container nopadding dialog-normal-form-field">
                      <mat-divider></mat-divider>
                      <p-table id = "handlingInstructionTable" [columns]="handlingInstructionCols" [value]="handlingInstructionData" #dt2
                      class = "cell-editor-table">
                        <ng-template pTemplate="caption">
                          <div class="row">
                              <div class="col-md-4" style="text-align:left">
                                  <span class="dialog-section-header"><b>Handling Instructions</b></span>
                                </div>
                                <div class="col-md-4" style="text-align:left">
                                  <p-multiSelect [name]="editRow.field_Name +'multiselect'" [id]="editRow.field_Name+'multiselect'" appendTo="body" [options]="this.userService.handlingInstructions" [(ngModel)]="handlingInstructionCols" optionLabel="header"
                                   selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px'}"  placeholder="Choose Columns" class="cat-exp-select"></p-multiSelect>
                              </div>
                          </div>     
                      </ng-template>
                        <ng-template pTemplate="header" let-columns>
                          <tr>
                            @for(col of columns; track col.header + '-'+ $index) { 
                            <th id="colHeader">
                              {{col.header}}
                            </th>
                            }
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-handlingInstructionData let-columns="columns">
                          <tr >
                            @for(col of columns; track col.field + '-'+ $index) { 
                            <td style="width: 10px;" pEditableColumn>
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  <input  [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'"  [(ngModel)]="handlingInstructionData[col.field]">
                                </ng-template>
                                <ng-template pTemplate="output">
                                  <span >
                                    {{handlingInstructionData[col.field]}}
                                  </span>
                                </ng-template>
                            </p-cellEditor>
                            
                            </td>
                            }
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                    }
                    @if(editRow.field_Name=='buyDetails' || editRow.field_Name=='sellDetails' || editRow.field_Name=='clientDetails' || editRow.field_Name=='firmDetails' || editRow.field_Name=='legDetails'){
                    <div class="ui-grid-col-12 horizontal-scroll">
                      <mat-divider></mat-divider>
                      <span class="dialog-section-header"><b>{{editRow.field_Name === 'buyDetails' ? 'Buy Details': editRow.field_Name === 'sellDetails' ? 'Sell Details' : editRow.field_Name=='clientDetails' ? 'Client Details': editRow.field_Name=='firmDetails' ? 'Firm Details': editRow.field_Name=='legDetails' ? 'Leg Details': ''}}</b></span>
                      <p-table [columns]="getChildColumns(editRow.field_Name)" [value]="editRow.value" #dt2 class="cell-editor-table">
                        <ng-template pTemplate="header" let-columns>
                          <tr>
                            @if((editRow.field_Name | lowercase)==='legdetails') {
                              <th id="tableHeader"></th>
                            }
                            @for(col of columns; track col.header + '-'+ $index) { 
                            <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              {{col.header}}
                            </th>
                            }
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-tradeSideRowData let-rowIndex="rowIndex" let-columns="columns">
                          <tr [pSelectableRow]="tradeSideRowData">
                            <!-- Logic of Leg Details Add/Delete Row Buttons -->
                              @if((editRow.field_Name | lowercase)==='legdetails' && (editRow.value.length === (rowIndex+1))){
                                <td class="text-center">
                                  @if(editRow.value.length > 1) {
                                    <a (click)="dataService.removeJsonFieldDetails(editRow.value, rowIndex)"><em class="pi pi-minus"></em></a>&nbsp;
                                  }
                                  <a (click)="dataService.addJsonFieldDetails(editRow.value, 'legDetails');"><em class="pi pi-plus"></em></a>
                                </td>
                              }
                              @if((editRow.field_Name | lowercase)==='legdetails' && (editRow.value.length !== (rowIndex+1))){
                                <td class="text-center"><a (click)="dataService.removeJsonFieldDetails(editRow.value, rowIndex)"><em class="pi pi-minus"></em></a></td>
                              }
                            <!-- End Logic of Leg Details Add/Delete Row Buttons -->
                            @for(col of columns; track col.field + '-'+ $index) { 
                            <td  [style]="editRow.field_Name==='side' ? 'min-width: 160px !important' : 'min-width: 30px  !important'" pEditableColumn [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                              <p-cellEditor>
                                <ng-template pTemplate="input">
                                  @if((col.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no'){
                                    <input [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'" [(ngModel)]="tradeSideRowData[col.field]">
                                  }
                                  <!-- set dropdown -->
                                  @if((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect'){
                                    <p-select styleClass="tbl-form-dropdown" appendTo="body" [name]="tradeSideRowData[col.field]+'singleselect'" [id]="tradeSideRowData[col.field]+'singleselect'" 
                                      [options]="getCATDetailsFieldDropdownValues(editRow, col, tradeSideRowData)" [(ngModel)]="tradeSideRowData[col.field]" [disabled]="col.disabled" [showClear]="true" 
                                      [placeholder]="'Enter Value'">
                                    </p-select>
                                  }
                                  <!-- set int  -->
                                  @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
                                  <input  [name]="editRow.field_Name +'inp'" [id]="editRow.field_Name+'inp'"
                                    [(ngModel)]="tradeSideRowData[col.field]">
                                  }
                                  <!-- set boolean -->
                                  @if((col.datatype | lowercase)==='boolean') {
                                    <p-select [name]="editRow.field_Name + 'boolean'" [id]="editRow.field_Name + 'boolean'" [options]="BooleanDropDown" [(ngModel)]="tradeSideRowData[col.field]" appendTo="body"
                                      [styleClass]="editRow.isMultiEdited ? 'drp-color-style-edit' : 'drp-color-style'"
                                      [placeholder]="editRow.isMultiEdited ? 'Value cleared' : 'Enter Value'" [showClear]="true"
                                      (ngModelChange)="editRow.isMultiEdited=true" filter="true"></p-select>
                                  }
                                </ng-template>
                                <ng-template pTemplate="output">
                                  @if((col.datatype | lowercase)==='string' || (col.datatype | lowercase)==='boolean'){
                                  <span>
                                    {{tradeSideRowData[col.field]}}
                                  </span>
                                  }
                                  <!-- set int, float -->
                                  @if((col.datatype | lowercase)==='int' || (col.datatype | lowercase)==='float'){
                                  <span style="float:right;">
                                    {{tradeSideRowData[col.field]}}
                                  </span>
                                  }
                                </ng-template>
                            </p-cellEditor>
                              <!-- set String -->
                            </td>
                            }
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                    }
                  </span>
                }
                </span>
              </ng-container>
              }
      </mat-step>
      @if(isShowConvertEventStepper && this.selectedRow.length === 1){
      <mat-step label="Convert Event">
        <app-event-conversion [fieldDictionaryListInput]="fieldDictionaryList" [pageName]="'catException'" [selectedRow]="selectedRow[0]" (closeDialog)="getData();Edit =false"></app-event-conversion>
      </mat-step>
      }
     
    </mat-horizontal-stepper>
  </div>
  @if(selectedTabIndex === 0){
    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <p-button type="button" icon="fa fa-close" id="catExceptionClose" class="userActionBtn cat-close-footer-button cat-edit-footer-button" (click)="closeDialog()" label="Close"></p-button>
      <p-button type="button" icon="fa fa-check" [disabled]="isClickedOnce || !!this.userService.timeStampErrorField" class="userActionBtn cat-edit-footer-button" (click)="save()" id="catExceptionSave" label="Save"></p-button>
    </div>
    </ng-template>
  }
</p-dialog>
}

<!-- Quick View Panel Code  -->
<p-drawer styleClass="u ui-sidebar-lg"
  [style]="{'width':'auto','max-width': '920px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="View" position="right" [baseZIndex]="10000">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-col-12">
        @for(ViewRow of Editviewcols; track ViewRow.ui_Field_Name + '-'+ $index) { 
        <div class="ui-grid-col-6"> <span>
          <div class="ui-grid-col-4 quick-view-grid-row-hg">
            <label for="ui_Field_Name">{{ViewRow.ui_Field_Name}}</label>
          </div>
          <div lass="ui-grid-col-3 quick-view-grid-row-hg">
            @if((ViewRow?.datatype | lowercase)!=='boolean'){
            <input [disabled]="true" pInputText [(ngModel)]="ViewRow.value" style="width:65%" class="cat-view-input"/>
            }
            @if((ViewRow?.datatype | lowercase)=='boolean'){
            <input [disabled]="true" pInputText [value]="getBooleanValue(ViewRow.value)" style="width:65%" class="cat-view-input"> 
            }
          </div>
        </span>
      </div>
    }
    </div>
</div>
</p-drawer>

@if(this.eventTreeService.isDialogOpen){
<app-event-tree-dialog 
id="cat-exceptions-parent-child-event-tree" 
[SelectedRow]="selectedRow"
[isTreeOpen]="this.eventTreeService.isDialogOpen"
[pageName]="ApplicationName">
</app-event-tree-dialog>
}

@if(isAuditTrail){
<app-audit-trail-dialog 
id="cat-exceptions-audit-trail" 
(closeEventDialog)="isAuditTrail = false"
[SelectedRow]="selectedRow"
[isAuditTrailOpen]="isAuditTrail"
[pageName]="ApplicationName">
</app-audit-trail-dialog>
}


<!-- View MultiLeg Events -->
 @if(viewMultiLegEvent){
<app-multileg-event
  id="multileg_event"
  [index]="rowIndexForDialog"
  [rowData]="rowDataforDialog"
  [showMultiLegEvent]="viewMultiLegEvent"
  (closeMultiLegEvent)="closeMultiLegEvent()">
</app-multileg-event>
 }

 @if(displayNewROEDialog){
<app-new-roe-entry
[selectedEventType]="selectedEventType"
[selectedID]="selectedID"
[pageName]="'CAT-Exception'"
[reportDate]="selectedReportDate"
[existingEventType]="existingEventType"
[selectedGroupName]="selectedGroupName"
[selectedFileID]="selectedFileID"
[rowData]="selectedRow"
[CATReporterIMID]="CATReporterIMID"
(closeDropdown)="closeDropdown($event)" 
>
</app-new-roe-entry>
 }

 @if(viewFDID){
  <app-view-fdid [viewFDIDOpen]="viewFDID" [displaySideBar]="displaySideBar" [selectedFDIDDetails]="selectedFDIDDetails"
  (closeDialog)="onClickCancelFDID()"></app-view-fdid>
 }
